angular.
module("dx.webapp.lists").
controller("DxRubricEntryController", function RubricEntryController(
	$rootScope,

	DX_URLS,
	dxRubricsRepository,
	dxSession,
	RoleTypeEnum,
	faults,
	dxApi,
	DX_SHARE,

	dxDialog,
	dxLocalize
) {
	"use strict";

	var self = this;

	self.Urls = DX_URLS;

	/* State helpers */

	self.isShared = function isShared() {
		if (dxSession.getRole().roleType === RoleTypeEnum.TEACHER) {
			return dxSession.getUser().id !== self.rubric.userId;
		} else if (dxSession.getRole().roleType === RoleTypeEnum.ADMIN) {
			return dxSession.getRole().organizationId !== self.rubric.organizationId;
		}

		return false;
	};

	/* Actions */

	self.shareRubric = function shareRubric() {
		var popupScope = $rootScope.$new();
		popupScope.sharedToUser = [];
		popupScope.item = {
			displayName: self.rubric.title,
			ownerId: self.rubric.userId,
		};
		popupScope.rubricId = self.rubric.id;
		popupScope.type = DX_SHARE.RUBRIC;

		dxApi.v1.rubrics.shares.get(self.rubric.id).then(function onReturn(response) {
			popupScope.sharedToUser = response.data.users || [];
			popupScope.ownerName = response.data.ownerName;
		});

		popupScope.confirm = function confirm() {
			var shareItemControllerScope = this; // eslint-disable-line consistent-this
			shareItemControllerScope.loading = true;

			function successHandler(response) {
				shareItemControllerScope.loading = false;

				if (!response.faults) {
					shareItemControllerScope.close();
					$rootScope.$broadcast(
						"notification:success",
						dxLocalize.get("YouSharedXWithY", shareItemControllerScope.item.displayName, shareItemControllerScope.email)
					);
				} else if (response.faults.indexOf(faults.USER_NOT_FOUND) >= 0) {
					shareItemControllerScope.error = "ForgotPassword.Fail.EmailNotFound";
				} else if (response.faults.indexOf(faults.FORBIDDEN) >= 0) {
					shareItemControllerScope.error = "CouldNotShareCantHandleRubrics";
				} else {
					$rootScope.$broadcast("notification:error", dxLocalize.get("FailedToShareRubric"));
				}
			}

			function errorHandler() {
				shareItemControllerScope.loading = false;
				$rootScope.$broadcast("notification:error", dxLocalize.get("FailedToShareRubric"));
			}

			return self.rubric.share(shareItemControllerScope.email).then(successHandler).catch(errorHandler);
		};

		dxDialog.show({
			templateUrl: "partials/popups/share-item.html",
			$scope: popupScope,
		});
	};

	self.archiveRubric = function archiveRubric() {
		self.rubric.isArchived = true;

		function successHandler() {
			$rootScope.$broadcast("notification:success", dxLocalize.get("Feedback.SuccessArchived"));
		}

		function errorHandler() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("Feedback.ErrorArchiving"));
			self.rubric.isArchived = false;
		}

		dxRubricsRepository.save(self.rubric).then(successHandler).catch(errorHandler);
	};

	self.removeShare = function removeShare() {
		function remove() {
			dxRubricsRepository.removeShare(self.rubric).then(function success(response) {
				if (!response) {
					$rootScope.$broadcast("notification:error", dxLocalize.get("Feedback.CouldNotRemoveShare"));
				}
			});

			dxDialog.closeMostRecent();
		}

		return dxDialog.confirm({
			title: dxLocalize.get("Rubrics.RemoveSharedRubric"),
			body: dxLocalize.get("Rubrics.ThePersonWhoSharedTheRubricWillStillHaveAccessToIt"),
			acceptText: dxLocalize.get("Rubrics.RemoveRubric"),
			acceptCallback: remove,
			rejectText: dxLocalize.get("Cancel"),
		});
	};
});

